import { NgModule } from '@angular/core';
import { SharedMaterialModule } from 'core-client/api';

@NgModule({
  imports: [SharedMaterialModule],
  exports: [SharedMaterialModule]
})
export class CustomThemeModule { }
